import { lazy } from "react";
import { Navigate } from "react-router";
import Loadable from "src/routes/Loadable";

const BrandSettings = Loadable(lazy(() => import("src/pages/settings/brand")));
const BusinessSettings = Loadable(
  lazy(() => import("src/pages/settings/business/index"))
);
const NetworkSettings = Loadable(
  lazy(() => import("src/pages/settings/network/index"))
);

const Withdrawal = Loadable(
  lazy(() => import("src/pages/settings/withdrawal/index"))
);

const LevelSettings = Loadable(
  lazy(() => import("src/pages/settings/network/components/level/index"))
);
const ClipSettings = Loadable(
  lazy(() => import("src/pages/settings/network/C-LIP"))
);
const LifePlan = Loadable(
  lazy(() => import("src/pages/settings/network/lifePlan/LifePlan"))
);
const SIPSettings = Loadable(
  lazy(() => import("src/pages/settings/network/SIP"))
);
const IDPSettings = Loadable(
  lazy(() => import("src/pages/settings/network/idpIndex"))
);

const settings = [
  {
    path: "settings",
    children: [
      { element: <Navigate to="brand" />, index: true },
      { path: "brand", element: <BrandSettings /> },
      { path: "business", element: <BusinessSettings /> },
      { path: "network", element: <NetworkSettings /> },
      { path: "withdrawal", element: <Withdrawal /> },
      { path: "level_settings", element: <LevelSettings /> },
      { path: "clip", element: <ClipSettings /> },
      { path: "life", element: < LifePlan/> },
      { path: "sip", element: <SIPSettings /> },
      { path: "idp", element: <IDPSettings /> },
    ],
  },
];

export default settings;
